import { Button, Modal } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import useComposeLinking from '../../../../containers/compose/hooks/useComposeLinking';
import { MessageStatus } from '../../../../generated/graphql';
import translate from '../../../../i18n/translate';

import ComposeStatusSelection from '../../../Compose/Common/ComposeStatusSelection';

import * as Styled from './styled';

type Props = {
  dataStatusCurrent: MessageStatus;
  requestStatusChange: (status: MessageStatus) => void;
};

/**
 * Status selection for compose modal
 *
 * @param props                     Props passed to the component
 * @param props.dataStatusCurrent   Currently selected status
 * @param props.requestStatusChange Request that selected status is changed
 *
 * @returns                         Component itself
 */
const ComposeStatus: FC<Props> = ({
  dataStatusCurrent,
  requestStatusChange,
}) => {
  const navigate = useNavigate();
  const { isActive, linkToggleProps } = useComposeLinking('status');

  const [currentStatus, setCurrentStatus] =
    useState<MessageStatus>(dataStatusCurrent);

  useEffect(() => {
    // Reset status state if modal is closed and status is not saved
    if (!isActive) {
      setCurrentStatus(dataStatusCurrent);
    }
  }, [dataStatusCurrent, isActive]);

  /**
   * Handle close the modal
   */
  const handleClose = () => {
    navigate(linkToggleProps.to, { replace: linkToggleProps.replace });
  };

  /**
   * Handle status save
   */
  const handleSave = () => {
    requestStatusChange(currentStatus);
    handleClose();
  };

  return (
    <Modal
      onClose={handleClose}
      open={isActive}
      slotProps={{
        root: {
          style: Styled.WrapperRootStyles,
        },
      }}
    >
      <Styled.StatusWrapper>
        <ComposeStatusSelection
          currentStatus={currentStatus}
          onStatusChange={setCurrentStatus}
        />
        <Button onClick={handleSave}>{translate('GENERAL__SAVE')}</Button>
      </Styled.StatusWrapper>
    </Modal>
  );
};

export default ComposeStatus;
